import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Http\Controllers\ShareController::create
* @see app/Http/Controllers/ShareController.php:669
* @route '/share/folder'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: create.url(options),
    method: 'post',
})

create.definition = {
    methods: ["post"],
    url: '/share/folder',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ShareController::create
* @see app/Http/Controllers/ShareController.php:669
* @route '/share/folder'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ShareController::create
* @see app/Http/Controllers/ShareController.php:669
* @route '/share/folder'
*/
create.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: create.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ShareController::create
* @see app/Http/Controllers/ShareController.php:669
* @route '/share/folder'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: create.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ShareController::create
* @see app/Http/Controllers/ShareController.php:669
* @route '/share/folder'
*/
createForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: create.url(options),
    method: 'post',
})

create.form = createForm

/**
* @see \App\Http\Controllers\ShareController::update
* @see app/Http/Controllers/ShareController.php:721
* @route '/share/folder/{id}'
*/
export const update = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/share/folder/{id}',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\ShareController::update
* @see app/Http/Controllers/ShareController.php:721
* @route '/share/folder/{id}'
*/
update.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return update.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ShareController::update
* @see app/Http/Controllers/ShareController.php:721
* @route '/share/folder/{id}'
*/
update.patch = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\ShareController::update
* @see app/Http/Controllers/ShareController.php:721
* @route '/share/folder/{id}'
*/
const updateForm = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ShareController::update
* @see app/Http/Controllers/ShareController.php:721
* @route '/share/folder/{id}'
*/
updateForm.patch = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\ShareController::deleteMethod
* @see app/Http/Controllers/ShareController.php:773
* @route '/share/folder'
*/
export const deleteMethod = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(options),
    method: 'delete',
})

deleteMethod.definition = {
    methods: ["delete"],
    url: '/share/folder',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ShareController::deleteMethod
* @see app/Http/Controllers/ShareController.php:773
* @route '/share/folder'
*/
deleteMethod.url = (options?: RouteQueryOptions) => {
    return deleteMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ShareController::deleteMethod
* @see app/Http/Controllers/ShareController.php:773
* @route '/share/folder'
*/
deleteMethod.delete = (options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: deleteMethod.url(options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ShareController::deleteMethod
* @see app/Http/Controllers/ShareController.php:773
* @route '/share/folder'
*/
const deleteMethodForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ShareController::deleteMethod
* @see app/Http/Controllers/ShareController.php:773
* @route '/share/folder'
*/
deleteMethodForm.delete = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: deleteMethod.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

deleteMethod.form = deleteMethodForm

/**
* @see \App\Http\Controllers\ShareController::unlock
* @see app/Http/Controllers/ShareController.php:618
* @route '/share/folder/{id}/unlock'
*/
export const unlock = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unlock.url(args, options),
    method: 'post',
})

unlock.definition = {
    methods: ["post"],
    url: '/share/folder/{id}/unlock',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ShareController::unlock
* @see app/Http/Controllers/ShareController.php:618
* @route '/share/folder/{id}/unlock'
*/
unlock.url = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { id: args }
    }

    if (Array.isArray(args)) {
        args = {
            id: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        id: args.id,
    }

    return unlock.definition.url
            .replace('{id}', parsedArgs.id.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ShareController::unlock
* @see app/Http/Controllers/ShareController.php:618
* @route '/share/folder/{id}/unlock'
*/
unlock.post = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unlock.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ShareController::unlock
* @see app/Http/Controllers/ShareController.php:618
* @route '/share/folder/{id}/unlock'
*/
const unlockForm = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unlock.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ShareController::unlock
* @see app/Http/Controllers/ShareController.php:618
* @route '/share/folder/{id}/unlock'
*/
unlockForm.post = (args: { id: string | number } | [id: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unlock.url(args, options),
    method: 'post',
})

unlock.form = unlockForm

const folder = {
    create: Object.assign(create, create),
    update: Object.assign(update, update),
    delete: Object.assign(deleteMethod, deleteMethod),
    unlock: Object.assign(unlock, unlock),
}

export default folder